import {accountPaths} from '~/utils/services/paths';
import {$cpFetch} from '~/composables/useCpFetch';
import {useCpUser} from '~/composables/useCpUser';
import type {IAccountPublicProfile} from '~/types';

export type updatePublicProfilePayload = {
    name: string
    alias: string
    location: string
    sex: string
    profile: string
}

export type updatePublicProfileResponse = {
    status: string,
    msg: string
}

export type updateAccountNameParams = {
    name: string
}
export const getPublicProfile = () => {
    return $cpFetch<IAccountPublicProfile>(accountPaths.publicProfile(useCpUser().userId!));
};

export const updatePublicProfile = (payload: updatePublicProfilePayload) => {
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      formData.append(key, value);
    });
    return $cpFetch<updatePublicProfileResponse>(accountPaths.updatePublicProfile(useCpUser().userEmail!), {
        method: 'POST',
        body: formData,
    });
};

export const updateAccountUserName = (params: updateAccountNameParams) => {
    return $cpFetch(accountPaths.user(useCpUser().userEmail!), {
        method: 'PATCH',
        body: {
            type: 'updateName',
            props: params,
        },
    });
};
